import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';

import { TICKET_TYPE_STANDALONE, TICKET_TYPE_NESTED, TICKET_TYPE_ADD_ON } from './selectors';

const parseValueToInt = (value) => parseInt(value, 10);

export const MAPPED_TICKET_INPUT_KEYS_TO_TICKET_TYPE_ENTITY_KEYS = {
    ticketId: 'id',
    ticketName: 'label',
    openPrice: 'isOpenPrice',
    name: 'label',
};

export const MAPPED_TICKET_INPUT_VALUES_TO_TICKET_TYPE_ENTITY_VALUES = {
    id: (value) => `${value}`,
    quantity: (value) => parseValueToInt(value),
    quantityRemaining: (value) => parseValueToInt(value),
    minQuantityPerOrder: (value) => parseValueToInt(value),
    maxQuantityPerOrder: (value) => parseValueToInt(value),
    price: (value) => (parseValueToInt(value) / 100).toFixed(2),
    showRemaining: (value) => !!parseValueToInt(value),
    isOpenPrice: (value) => !!parseValueToInt(value),
    minOpenPrice: (value) => parseFloat(value),
    maxOpenPrice: (value) => parseFloat(value),
};

export const getTicketCategory = ({ isNestedUnder, isAddonFor }) =>
    (isNestedUnder && TICKET_TYPE_NESTED) || (isAddonFor && TICKET_TYPE_ADD_ON) || TICKET_TYPE_STANDALONE;

export const getFormattedTicketTypePayloadByKeys = (ticketTypePayload) => ({
    ...mapKeys(ticketTypePayload, (value, key) => MAPPED_TICKET_INPUT_KEYS_TO_TICKET_TYPE_ENTITY_KEYS[key] || key),
    category: getTicketCategory(ticketTypePayload),
});

export const getFormattedTicketTypePayloadByValues = (ticketTypePayload) => ({
    ...mapValues(ticketTypePayload, (value, key) =>
        MAPPED_TICKET_INPUT_VALUES_TO_TICKET_TYPE_ENTITY_VALUES[key]
            ? MAPPED_TICKET_INPUT_VALUES_TO_TICKET_TYPE_ENTITY_VALUES[key](value)
            : value,
    ),
    isSoldOut: ticketTypePayload.quantityRemaining <= 0,
});
